import { Component, OnInit } from '@angular/core';
import { BaseMapSidePanelComponent } from '@common-modules/wlm-map/components/side-panel/base-map-side-panel.component';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MasterOperatorConnectItemsSettings } from '../models/master-operator-connect-settings';

const COMPONENT_SELECTOR = 'tc-master-operator-simulate-form-sidepanel';

@UntilDestroy()
@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './master-operator-simulate-form-sidepanel.component.html',
    styleUrls: ['./master-operator-simulate-form-sidepanel.component.scss'],
    standalone: false
})
export class MasterOperatorSimulateFormSidepanelComponent
  extends BaseMapSidePanelComponent
  implements OnInit
{
  connectSettings: MasterOperatorConnectItemsSettings;

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.itemSettings?.params) {
      const { connectSettings$ } = this.itemSettings.params();
      if (connectSettings$) {
        connectSettings$.subscribe((connectSettings) => (this.connectSettings = connectSettings));
      }
    }
  }
}
